<app-main-layout>
  <app-clients-page></app-clients-page>
</app-main-layout>
